module.exports = __webpack_public_path__ + "img/pip-fill.320e06c5.svg";